var map = {
	"./elementary/stage1.svg": 34693,
	"./elementary/stage2.svg": 1376,
	"./elementary/stage3.svg": 1231,
	"./elementary/stage4.svg": 73436,
	"./elementary/stage5.svg": 15625,
	"./elementary/stage6.svg": 62701,
	"./high/stage1.svg": 10386,
	"./high/stage2.svg": 99654,
	"./high/stage3.svg": 29707,
	"./high/stage4.svg": 36297,
	"./high/stage5.svg": 86842,
	"./high/stage6.svg": 50605,
	"./high/stage7.svg": 422,
	"./middle/stage1.svg": 3740,
	"./middle/stage2.svg": 59478,
	"./middle/stage3.svg": 83238,
	"./middle/stage4.svg": 1850,
	"./middle/stage5.svg": 18833,
	"./middle/stage6.svg": 79335,
	"./middle/stage7.svg": 58909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 610;